package one.healthium.tasks.ui

import one.healthium.tasks.domain.DailyTaskModel

data class DailyTasksUiState(
    val loading: Boolean = false,
    val tasks: List<DailyTaskModel>? = null,
    val hasUnread: Boolean = false,
) {
    val progress = if (!tasks.isNullOrEmpty()) {
        tasks.sumOf { if (it.completed) 1L else 0 } / tasks.size.toFloat()
    } else {
        0f
    }
    val tasksUiModel = DailyTasksUiModel(tasks)
}
